import executeAction from './executeAction';
import parseLegacyMessageCardAction from './parseLegacyMessageCardAction';
import registerActions from './registerActions';
import registerHostCapabilities from './registerHostCapabilities';
import { ActionProvider } from 'owa-actionable-message-v2';

const cardActionProvider: ActionProvider = {
    registerActions: registerActions,
    executeAction: executeAction,
    parseLegacyMessageCardAction: parseLegacyMessageCardAction,
    registerHostCapabilities: registerHostCapabilities,
};

export default cardActionProvider;
